<template>
	<div>
		<nuxt-link
			:id="blok.uuid"
			:to="'/' + blok.full_slug"
			:aria-label="blok.content?.title"
			class="flex w-full shrink-0 flex-col space-y-sm md:w-auto lg:w-auto"
		>
			<nuxt-picture
				v-if="blok.content?.image?.filename"
				:src="blok.content.image.filename"
				:alt="blok.content.title"
				class="aspect-square w-full"
				loading="lazy"
				provider="storyblok"
				sizes="xs:60vw md:240px lg:325px xl:411px 2xl:496px"
				:img-attrs="{
					class: 'rounded-2xs object-cover w-full h-full',
				}"
			/>

			<div class="space-y-xs">
				<span
					class="font-prenton-cond text-2xl tracking-2xl wrap-break-word xl:text-3xl"
				>
					{{ addHyphens(blok.content?.title) }}
				</span>

				<!-- Rendering this can take surprisingly long and isn't
                crucial, so don't render it on the server-side or until the
                page is otherwise ready -->
				<div
					v-if="mounted && blok.content?.ingress"
					class="not-prose line-clamp-1 overflow-hidden text-sm leading-6 tracking-xl wrap-break-word text-ellipsis text-gray-750"
				>
					<sb-rich-text :document="blok.content?.ingress"></sb-rich-text>
				</div>
			</div>
		</nuxt-link>
	</div>
</template>

<script setup lang="ts">
import type {ISbStoryData} from "storyblok-js-client";

import {useHyphenation} from "@pkg/shared/composables/use-hyphenation";
defineProps<{
	article?: string;
	blok: ISbStoryData;
}>();

const {hyphenate: addHyphens} = useHyphenation();

const mounted = ref(false);

onMounted(() => {
	mounted.value = true;
});
</script>
